var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Wifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6 30.22l-2.68 3a33.29 33.29 0 00-43.85.06l-2.67-3a37.28 37.28 0 0149.2-.06zM19.46 37l2.68 3a24.24 24.24 0 0131.71-.07l2.68-3a28.24 28.24 0 00-37.07.07zm6.39 7.09l2.67 3A14.85 14.85 0 0147.47 47l2.68-3a18.83 18.83 0 00-24.3.09zM40.65 50a6.349 6.349 0 00-2.65-.62c-.4-.001-.798.04-1.19.12a6.27 6.27 0 00-3.62 2.1l4.72 4.69 4.87-4.71A6.53 6.53 0 0040.65 50z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Wifi.60ea769b.svg";
export { SvgG1Wifi as ReactComponent };